<template>
  <AuthLayout v-if="!isAuth" />
  <MainLayout v-else />
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue'
import AuthLayout from './components/partials/AuthLayout.vue'
import MainLayout from '@/components/partials/MainLayout.vue'
import { useAuthStore, useUtilsStore } from './stores'

const useUtils = useUtilsStore()
const useAuth = useAuthStore()
const isAuth = computed(() => useAuth.isAuth)

onMounted(() => {
  useUtils.listenOnlineStatus()
})
</script>

<style></style>
